import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { isEmpty } from 'lodash';

export interface LinkParams {
    routerLink: any[] | string;
    queryParams?: { [k: string]: any };
    preserveQueryParams?: boolean;
    text: string | number;
    linkIcon?: string;
    toString: () => string;
}

@Component({
    selector: 'link-cell',
    template: require('./link-ag-renderer.component.html'),
    styles: [require('./link-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkAgRendererComponent implements AgRendererComponent {
    public params: LinkParams;
    public isQuestion = false;

    public agInit(row: { value: LinkParams }): void {
        this.params = row.value;
    }

    public refresh() {
        return false;
    }

    public get isLink() {
        return this.params && !isEmpty(this.params.routerLink);
    }

    public get tooltipText() {
        return this.params ? this.params.text : null;
    }
}